const zIndices: number[] = [-1, 0, 1, 2, 3, 4, 5, 10, 50, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000, 9999];

export { zIndices };
